import { Injectable } from '@angular/core';
import { BaseApiService } from '@data-access/common/base-api.service';
import { GetFilter, GetPagination } from '@shared/interfacres/request-related';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CreateUserPayload, UsersWithPagination } from '@shared/interfacres/user';


@Injectable({providedIn: 'root'})
export class UsersManagerService extends BaseApiService {
  getPerformanceTypes() {
    const types: string[] = ["Mobile", "Touring/Festival", "Club", "Radio"]
    return of(types).pipe(
      map((response) => this.returnResponseData(response)),
      catchError(this.handleError)
    )
  }

  getFilteredList(
    name: string,
    filter: GetFilter,
    pagination: GetPagination
  ): Observable<UsersWithPagination> {

    let apiUrl = `${this.apiUrl}/admin/users?page=${pagination.page}&limit=${pagination.pageSize}&sortBy=${filter.query}&sortDirection=${filter.order}`;
    if (name) {
      apiUrl += `&search=${name}`;
    }
    return this._httpClient.get<UsersWithPagination>(apiUrl).pipe(
      map((response: UsersWithPagination) => this.returnResponseData(response)),
      catchError(this.handleError)
    )
  }

  update(id: string, payload: Partial<CreateUserPayload>) {
    const url = `${this.apiUrl}/admin/users/${id}`;
    return this._httpClient.put(url, payload).pipe(
      map((response) => this.returnResponseData(response)),
      catchError(this.handleError)
    );
  }

  approval(userId: string, isApproved: boolean) {
    const url = `${this.apiUrl}/admin/users/approval`;
    return this._httpClient.patch(url, {userId, isApproved}).pipe(
      map((response) => this.returnResponseData(response)),
      catchError(this.handleError)
    );
  }

  reject(userId: string, isRejected: boolean) {
    const url = `${this.apiUrl}/admin/users/reject`;
    return this._httpClient.patch(url, {userId, isRejected}).pipe(
      map((response) => this.returnResponseData(response)),
      catchError(this.handleError)
    );
  }

  delete(userId: string) {
    const url = `${this.apiUrl}/admin/users/${userId}`;
    return this._httpClient.delete(url).pipe(
      map((response) => this.returnResponseData(response)),
      catchError(this.handleError)
    );
  }

}
